import React from "react";
import Header from "@/components/layout/Header";
import Footer from "@/components/layout/Footer";

export default function PublicLayout({ children, menuKey }) {
  return (
    <div className="min-h-screen flex flex-col bg-slate-50">
      <Header menuKey={menuKey || "main"} />
      <main className="flex-1 pt-24">{children}</main>
      <Footer />
    </div>
  );
}
